"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryActivityList = void 0;
var TimeUtil_1 = require("../../utils/TimeUtil");
var HistoryActivityList = /** @class */ (function (_super) {
    __extends(HistoryActivityList, _super);
    function HistoryActivityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDateStartSorted = function () {
            var activityList = new HistoryActivityList();
            if (_this.length > 0) {
                _this.sort(function (x, y) {
                    var dateAwardedX = !!x.date_awarded ? x.date_awarded : 0;
                    var dateAwardedY = !!y.date_awarded ? y.date_awarded : 0;
                    return dateAwardedX > dateAwardedY ? -1 : 1;
                })
                    // .filter((x, index) => index < TOP_LIST_ITEMS)
                    .forEach(function (x) {
                    var baseNumPoints = parseInt(x.base_num_points, 10);
                    if (x.num_points !== baseNumPoints && baseNumPoints > 0 && x.num_points > baseNumPoints) {
                        x.bonusPoints = x.num_points - baseNumPoints;
                    }
                    x.dateAwarded = x.date_awarded !== null ? TimeUtil_1.formatUnixMonthOrdinalDayYear(x.date_awarded) : null;
                    activityList.push(x);
                });
            }
            return activityList;
        };
        return _this;
    }
    return HistoryActivityList;
}(Array));
exports.HistoryActivityList = HistoryActivityList;
//# sourceMappingURL=HistoryActivityList.js.map